<div class="font-bold mb-3" i18n>Do you have a M2M Remote Provisioning System according to GSMA SGP.01?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="m2mConnectivityParameters.m2mRemoteProvisioningSystem"
          inputId="m2mConnectivityParameters.m2mRemoteProvisioningSystem#1"
          value="1"
          [(ngModel)]="profileValues.m2mConnectivityParameters.m2mRemoteProvisioningSystem"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.m2mRemoteProvisioningSystem#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="m2mConnectivityParameters.m2mRemoteProvisioningSystem"
          inputId="m2mConnectivityParameters.m2mRemoteProvisioningSystem#0"
          value="0"
          [(ngModel)]="profileValues.m2mConnectivityParameters.m2mRemoteProvisioningSystem"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.m2mRemoteProvisioningSystem#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
<div *ngIf="+profileValues.m2mConnectivityParameters.m2mRemoteProvisioningSystem === 1" class="font-bold mt-3 mb-3" i18n>
  Let's set up the connectivity parameters for the Secure Element to use to notify the SM-SR.
</div>
<div *ngIf="+profileValues.m2mConnectivityParameters.m2mRemoteProvisioningSystem === 1" class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <span class="font-bold mr-6" i18n>Select the protocol(s):</span>
      </td>
      <td colspan="2">
        <table>
          <tr>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="m2mConnectivityParameters.protocol"
                inputId="m2mConnectivityParameters.protocol#1"
                value="1"
                [(ngModel)]="profileValues.m2mConnectivityParameters.protocol"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.protocol#1" i18n>SMS</label>
            </td>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="m2mConnectivityParameters.protocol"
                inputId="m2mConnectivityParameters.protocol#2"
                value="2"
                [(ngModel)]="profileValues.m2mConnectivityParameters.protocol"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.protocol#2" i18n>HTTP</label>
            </td>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="m2mConnectivityParameters.protocol"
                inputId="m2mConnectivityParameters.protocol#3"
                value="3"
                [(ngModel)]="profileValues.m2mConnectivityParameters.protocol"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.protocol#3" i18n>Both</label>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr *ngIf="+profileValues.m2mConnectivityParameters.protocol === 1 || +profileValues.m2mConnectivityParameters.protocol === 3">
      <td>
        <span class="font-bold mr-3" i18n>SMS Center Address:</span>
      </td>
      <td>
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.m2mConnectivityParameters.smsCenterAddress"
          (input)="handleFormEvents()"
          maxlength="20"
          rsPhoneNumberInput
        />
      </td>
      <td><div class="ml-1" i18n>(e.g., +44689924110)</div></td>
    </tr>
    <tr *ngIf="+profileValues.m2mConnectivityParameters.protocol === 2 || +profileValues.m2mConnectivityParameters.protocol === 3">
      <td>
        <span class="font-bold mr-3" i18n>Network Access Name:</span>
      </td>
      <td>
        <input
          class="maximize-inputs"
          type="text"
          pInputText
          [(ngModel)]="profileValues.m2mConnectivityParameters.networkAccessName"
          (input)="handleFormEvents()"
          maxlength="20"
        />
      </td>
      <td><div class="ml-1" i18n>(e.g., ripsim)</div></td>
    </tr>
    <tr *ngIf="+profileValues.m2mConnectivityParameters.protocol === 3">
      <td>
        <span class="font-bold mr-3" i18n>Priority:</span>
      </td>
      <td colspan="2">
        <table>
          <tr>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="m2mConnectivityParameters.priority"
                inputId="m2mConnectivityParameters.priority#1"
                value="1"
                [(ngModel)]="profileValues.m2mConnectivityParameters.priority"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.priority#1" i18n>SMS</label>
            </td>
            <td>
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="m2mConnectivityParameters.priority"
                inputId="m2mConnectivityParameters.priority#2"
                value="2"
                [(ngModel)]="profileValues.m2mConnectivityParameters.priority"
              ></p-radioButton>
            </td>
            <td>
              <label class="ml-2 mr-6 label-clickable" for="m2mConnectivityParameters.priority#2" i18n>HTTP</label>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
